import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import MuiCheckbox from "@material-ui/core/Checkbox"

const useStyles = makeStyles((theme) => ({
  root: {
    // background: theme.palette.background.paper,
    // margin: 0,//theme.spacing(1),
    // width: "100%",//"calc(100% - " + theme.spacing(2) + "px)",
  },
}))

export default function Checkbox({ id, label, name, defaultValue, onChange }) {
  const classes = useStyles()

  return (
    <FormControlLabel
      className={classes.root}
      control={<MuiCheckbox checked={defaultValue} onChange={onChange} name={name} />}
      label={label}
    />
  )
}
